/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Flex_Title_NoneInputs */

const en_us2_profile_editors_flex_title_none = /** @type {(inputs: Profile_Editors_Flex_Title_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Days per week`)
};

const pt_br2_profile_editors_flex_title_none = /** @type {(inputs: Profile_Editors_Flex_Title_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias por semana`)
};

const es_419_profile_editors_flex_title_none = /** @type {(inputs: Profile_Editors_Flex_Title_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Días por semana`)
};

const pt_pt2_profile_editors_flex_title_none = /** @type {(inputs: Profile_Editors_Flex_Title_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias por semana`)
};

const fr_fr2_profile_editors_flex_title_none = /** @type {(inputs: Profile_Editors_Flex_Title_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jours par semaine`)
};

const de_de2_profile_editors_flex_title_none = /** @type {(inputs: Profile_Editors_Flex_Title_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tage pro Woche`)
};

const it_it2_profile_editors_flex_title_none = /** @type {(inputs: Profile_Editors_Flex_Title_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorni a settimana`)
};

/**
* | output |
* | --- |
* | "Days per week" |
*
* @param {Profile_Editors_Flex_Title_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_flex_title_none = /** @type {((inputs?: Profile_Editors_Flex_Title_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Flex_Title_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_flex_title_none(inputs)
	if (locale === "es-419") return es_419_profile_editors_flex_title_none(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_flex_title_none(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_flex_title_none(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_flex_title_none(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_flex_title_none(inputs)
	return en_us2_profile_editors_flex_title_none(inputs)
});
export { profile_editors_flex_title_none as "profile-editors.flex_title_none" }